import React from 'react';
import styled from 'styled-components';
import Typography from '../common/typography/Typography'; // Assuming Typography is the shared component

// Styled components
const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F1F5FF;
  padding: 54px 22px;
  text-align: left;
  margin-top: 32px;


`;

const FooterTop = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;

  @media (min-width: 600px) {
    flex-direction: row;
  }
`;

const FooterColumn = styled.div`
  
  display: flex;
  padding:5px;
  flex-direction: column;


  margin :5px;

  @media (min-width: 500px) {
    min-width: ${({ wide }) => (wide ? '40%' : '20%')};
  }
`;

const EmailInputContainer = styled.div`
  display: flex;
  width: 100%;
  padding-top:10px;
  @media (max-width: 768px) {
    flex-direction: row; 
  }
`;

const EmailInput = styled.input`
  flex: 5; 
  height:50px;

  padding: 16px;
  border: 1px solid #D9DBE9;
  border-radius: 8px;

  font-family: 'Gilroy', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #6F6C90;
`;

const SubscribeButton = styled.button`
  flex: 2;
    height:50px;

  background-color: #5B63F6;
  color: white;
  margin-left:10px;
  border: none;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: #777;
  }
`;

const FooterLinks = styled(Typography).attrs({ as: 'a' })`
  color: #6F6C90;
  text-decoration: none;
  margin:5px 0;

  &:hover {
    text-decoration: underline;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 64px;
  width: 100%;
  border-top: 1px solid #BCB3FF;

  @media (max-width: 600px) {
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    padding-top: 64px;
  }
`;

const SocialIconsContainer = styled.div`
  margin:10px 0;
  display: flex;
`;

const NewsletterContainer = styled.div`
  margin : 20px 0;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin :0 10px 0 0;
  width: 24px;
  height: 24px;
`;

// Copyright component
function Copyright() {
  return (
    <Typography size="20px" weight="500" color="#6F6C90" lineHeight="30px">
      {'Copyright © '} {new Date().getFullYear()} REALVERSE | All Rights Reserved
    </Typography>
  );
}

// Main Footer Component
const Footer = () => {
  return (
    <FooterContainer>
      <FooterTop>
        <FooterColumn wide>
          <div><img src="./static/logo.svg" alt="logo"/></div>
          <NewsletterContainer>
            <Typography size="20px" weight="700" lineHeight="30px">Subscribe to our newsletter</Typography>
            <Typography size="18px" weight="500" color="#6F6C90" lineHeight="27px">
              Subscribe for weekly updates. No spams ever!
            </Typography>
          </NewsletterContainer>
          <EmailInputContainer>
            <EmailInput placeholder="Enter your email" />
            <SubscribeButton>Subscribe</SubscribeButton>
          </EmailInputContainer>
        </FooterColumn>

        <FooterColumn>
          <Typography size="20px" weight="700" lineHeight="30px">Product</Typography>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Features</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Pricing</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Case studies</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Reviews</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Updates</FooterLinks>
        </FooterColumn>

        <FooterColumn>
          <Typography size="20px" weight="700" lineHeight="30px">Company</Typography>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">About</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Contact us</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Careers</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Culture</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Blog</FooterLinks>
        </FooterColumn>

        <FooterColumn>
          <Typography size="20px" weight="700" lineHeight="30px">Support</Typography>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Getting started</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Help center</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Server status</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Report a bug</FooterLinks>
          <FooterLinks size="18px" weight="500" lineHeight="27px" href="#">Chat support</FooterLinks>
        </FooterColumn>
      </FooterTop>

      <FooterBottom>
        <Copyright />
        <SocialIconsContainer>
          <SocialIcon href="#"><img src="./static/FacebookLogo.svg" alt="Facebook" /></SocialIcon>
          <SocialIcon href="#"><img src="./static/InstagramLogo.svg" alt="Instagram" /></SocialIcon>
          <SocialIcon href="#"><img src="./static/LinkedinLogo.svg" alt="LinkedIn" /></SocialIcon>
          <SocialIcon href="#"><img src="./static/YoutubeLogo.svg" alt="YouTube" /></SocialIcon>
          <SocialIcon href="#"><img src="./static/TwitterLogo.svg" alt="Twitter" /></SocialIcon>
          <SocialIcon href="#"><img src="./static/TwitchLogo.svg" alt="Twitch" /></SocialIcon>
        </SocialIconsContainer>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
